module.exports = "mutation ($data: CustomContractInput!) {\n  CustomContractCreate(data: $data) {\n    id\n  }\n}\n"